<template>
  <div class="caption pb-1">
    {{
    field.rules && field.rules.includes('required')
    ? `* ${field.label}`
    : field.label
    }}
    <v-btn
      @click="show = !show"
      color="secondary"
      fab
      width="16"
      height="16"
      depressed
      class="ml-1 mb-1"
      v-if="field.hint"
    >
      <v-icon size="10" color="white">mdi-help</v-icon>
    </v-btn>

    <v-expand-transition>
      <div v-if="show" class="pb-2 font-italic" v-html="field.hint"></div>
    </v-expand-transition>
  </div>
</template>

<script>
export default {
  name: 'FieldLabel',
  props: {
    field: {
      required: true,
      type: Object
    }
  },
  data: () => ({
    show: false
  })
}
</script>